<template>
<div id="customerCarInfo" class="container section-container">
  <el-row class="inlineBlock">
    <el-col :span="14">
      <el-form label-width="120px">
        <el-form-item label="选择车辆:">
          <el-select v-model="carInfo.plateNumber"
                     @change="getData()"
                     v-if="carInfo.hphmList && carInfo.hphmList.length > 0"
                     placeholder="车辆" clearable>
            <el-option v-for="(item, index) in carInfo.hphmList"
                       :value="item"
                       :key="item"
                       :label="item + (index == carInfo.isDefaultBind ? '(默认)' : '')">
            </el-option>
          </el-select>
          <div v-else>用户尚未绑车</div>
          <!-- <el-row>
            <el-col :span="5">违章 {{carInfo.vioCounts || '0'}}条</el-col>
            <el-col :span="5">扣分 {{carInfo.kfTotle || '0'}}分</el-col>
            <el-col :span="5">罚款 {{carInfo.fkjeTotle || '0'}}元</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="!carDataEdit.editCarBrand">{{carInfo.model || '-'}}
              <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editCarBrandInfo()"></i>
            </el-col>
            <el-col class="changeEditable small" :span="24" v-else>
              <el-select v-model="carDataEdit.dataCarBrand1"
                         @change="getCarType(carDataEdit.dataCarBrand1)"
                         placeholder="品牌" clearable>
                <el-option :value="item.brandId" :label="item.brandName" v-for="item in carBrandList" :key="item.brandId"></el-option>
              </el-select>
              <el-select v-model="carDataEdit.dataCarBrand2"
                         @change="getCarType(carDataEdit.dataCarBrand2, 2)"
                         placeholder="车系" clearable>
                <el-option :value="item.id" :label="item.name" v-for="item in carBrandList2" :key="item.brandId"></el-option>
              </el-select>
              <el-select v-model="carDataEdit.dataCarBrand3"
                         @change="getCarType(carDataEdit.dataCarBrand3, 3)"
                         placeholder="年份" clearable>
                <el-option :value="item.id" :label="item.name" v-for="item in carBrandList3" :key="item.brandId"></el-option>
              </el-select>
              <el-select v-model="carDataEdit.dataCarBrand4"
                         placeholder="配置" clearable>
                <el-option :value="item.id" :label="item.name" v-for="item in carBrandList4" :key="item.brandId"></el-option>
              </el-select>
              <i class="fa fa-check iconAble iconYes" title="保存" @click="saveCarInfo('CarBrand')"></i>
              <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleCarInfo('CarBrand')"></i>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6"><span class="likeA" @click="checkVehInfo">查看详情</span></el-col>
            <el-col :span="6"><span class="likeA" @click="clearCache">清除缓存</span></el-col>
          </el-row> -->
        </el-form-item>
        <!-- <el-form-item label="颜色:">
          <div v-if="!carDataEdit.editColor">
            {{carInfo.csys || '-'}} <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editCarInfo('Color')"></i>
          </div>
          <div class="changeEditable" v-else>
            <el-select v-model="carDataEdit.dataColor"
                       placeholder="颜色" clearable>
              <el-option value="红色" label="红色"></el-option>
              <el-option value="白色" label="白色"></el-option>
              <el-option value="蓝色" label="蓝色"></el-option>
              <el-option value="黑色" label="黑色"></el-option>
              <el-option value="金色" label="金色"></el-option>
              <el-option value="灰色" label="灰色"></el-option>
              <el-option value="其他" label="其他"></el-option>
            </el-select>
            <i class="fa fa-check iconAble iconYes" title="保存" @click="saveCarInfo('Color')"></i>
            <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleCarInfo('Color')"></i>
          </div>
        </el-form-item>
        <el-form-item label="购车价格:">
          <div v-if="!carDataEdit.editPrice">
            {{carInfo.gmjg || '0'}}元 <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editCarInfo('Price')"></i>
          </div>
          <div class="changeEditable" v-else>
            <el-input placeholder="购车价格" v-model="carDataEdit.dataPrice"></el-input>
            <i class="fa fa-check iconAble iconYes" title="保存" @click="saveCarInfo('Price')"></i>
            <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleCarInfo('Price')"></i>
          </div>
        </el-form-item> -->
        <el-form-item label="车辆注册日期:">
          <div v-if="!carDataEdit.editRegDate">
            {{carInfo.regDate || '-'}} <!-- <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editCarInfo('RegDate')"></i> -->
          </div>
          <div class="changeEditable" v-else>
            <el-date-picker
              v-model="carDataEdit.dataRegDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <i class="fa fa-check iconAble iconYes" title="保存" @click="saveCarInfo('RegDate')"></i>
            <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleCarInfo('RegDate')"></i>
          </div>
        </el-form-item>
        <el-form-item label="保险办理时间:">
          <div v-if="!carDataEdit.editBxDate">
            {{carInfo.insuranceExpire || '-'}} <!-- <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editCarInfo('BxDate')"></i> -->
          </div>
          <div class="changeEditable" v-else>
            <el-date-picker
              v-model="carDataEdit.dataBxDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <i class="fa fa-check iconAble iconYes" title="保存" @click="saveCarInfo('BxDate')"></i>
            <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleCarInfo('BxDate')"></i>
          </div>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="10">
      <el-form label-width="115px">
        <!-- <el-form-item label="行驶里程:">
          <div v-if="!carDataEdit.editDriveKm">
            {{carInfo.driveKm || '-'}}km <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editCarInfo('DriveKm')"></i>
          </div>
          <div class="changeEditable" v-else>
            <el-input placeholder="行驶里程" v-model="carDataEdit.dataDriveKm"></el-input>
            <i class="fa fa-check iconAble iconYes" title="保存" @click="saveCarInfo('DriveKm')"></i>
            <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleCarInfo('DriveKm')"></i>
          </div>
        </el-form-item>
        <el-form-item label="上次修改时间:">
          {{carInfo.driveKmUpdateTime || '-'}}
        </el-form-item> -->
        <el-form-item label="距离申请年检标:">
          {{carInfo.endDate || '-'}}
        </el-form-item>
        <el-form-item label="距离上线审车:">
          {{carInfo.onLineCheckDay || '-'}}
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>

  <el-dialog title="违章记录" :visible.sync="dialog.record.show" width="800px">
    <div class="contentView">
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column
          prop="wfsj"
          label="违章时间"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="wfdz"
          label="违章地点"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="wfxw"
          label="违章行为"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="cfje"
          label="罚金"
          min-width="80">
        </el-table-column>
        <el-table-column
          label="缴款状态"
          min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.jkzt == 0">未缴款</span>
            <span v-if="scope.row.jkzt == 1">已缴款</span>
            <span v-if="scope.row.jkzt == 9">无需缴款</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="kf"
          label="计分"
          min-width="60">
        </el-table-column>
        <el-table-column
          label="裁决状态"
          min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.clbj == 0">未裁决</span>
            <span v-if="scope.row.clbj == 1">已裁决</span>
            <span v-if="scope.row.clbj == 9">其他</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="cjjg"
          label="采集机关"
          min-width="80">
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: 'customerCarInfo',
  props: ['mobile', 'update'],
  data () {
    return {
      tableData: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      searchParams: {
        pageIndex: 0,
        pageSize: 10
      },
      carInfo: {},
      carBrandList: [],
      carBrandList2: [],
      carBrandList3: [],
      carBrandList4: [],
      carDataEdit: {
        editColor: false,
        dataColor: '',
        editPrice: false,
        dataPrice: '',
        editDriveKm: false,
        dataDriveKm: '',
        editRegDate: false,
        dataRegDate: '',
        editBxDate: false,
        dataBxDate: '',
        editCarBrand: false,
        dataCarBrand1: '',
        dataCarBrand2: '',
        dataCarBrand3: '',
        dataCarBrand4: ''
      },
      dialog: {
        record: {
          show: false
        }
      }
    };
  },
  watch: {
    'update' () {
      // 先格式化data
      this.tableData = [];
      this.currentPage = 1;
      this.totalResult = 0;
      this.totalPage = 0;
      this.searchParams = {
        pageIndex: 0,
        pageSize: 10
      };
      this.carInfo = {};
      this.carBrandList = [];
      this.carBrandList2 = [];
      this.carBrandList3 = [];
      this.carBrandList4 = [];
      this.carDataEdit = {
        editColor: false,
        dataColor: '',
        editPrice: false,
        dataPrice: '',
        editDriveKm: false,
        dataDriveKm: '',
        editRegDate: false,
        dataRegDate: '',
        editBxDate: false,
        dataBxDate: '',
        editCarBrand: false,
        dataCarBrand1: '',
        dataCarBrand2: '',
        dataCarBrand3: '',
        dataCarBrand4: ''
      };
      this.dialog = {
        record: {
          show: false
        }
      };
      this.getData();
    }
  },
  created () {
    this.getData();
  },
  methods: {
    // 获取数据
    getData () {
      let timer = () => {
        setTimeout(() => {
          if (!this.$store.state.memberId) return timer();
          if (this.mobile === '') return;
          this.axios.get(`/member/memberCarInfo`, {
            params: {
              mobile: this.mobile,
              plateNumber: this.carInfo.plateNumber || '',
              memberId: this.$store.state.memberId
            }
          })
            .then(res => {
              if (res.data.errorCode == 0) {
                this.carInfo = res.data.data;
                if (typeof this.carInfo !== 'string') {
                  this.carInfo.plateNumber = this.carInfo.hphm;
                }
              }
            });
        }, 500);
      };
      timer();
    },
    // 获取车辆品牌
    getCarBrand () {
      this.axios.get('/member/getVehBrand', { params: {} })
        .then(res => {
          this.carBrandList = res.data.resultData.brandslist;
        });
    },
    // 获取车辆车系、年份等信息
    getCarType (brandId, grade = 1) {
      let num = 0;
      grade === 1 && (num = 0);
      grade === 2 && (num = 1);
      grade === 3 && (num = 1);
      this.axios.get('/member/getVehTypeNew', { params: {
        brandid: brandId,
        type: num
      } })
        .then(res => {
          if (grade === 1) {
            this.carBrandList2 = res.data.resultData.vehTypeInfo[0].vehList;
          } else if (grade === 2) {
            this.carBrandList3 = res.data.resultData.vehTypeInfo;
          } else if (grade === 3) {
            this.carBrandList4 = res.data.resultData.vehTypeInfo;
          }
        });
    },
    // 查询违章详情
    checkVehInfo () {
      this.axios.post(`/member/getCarVehInfo`, {
        memberId: this.$store.state.memberId,
        clsbh: this.carInfo.clsbh,
        plateNumber: this.carInfo.plateNumber,
        type: 0 // 0查询 1清除缓存
      })
        .then(res => {
          if (res.data.isSuccess) {
            this.dialog.record.show = true;
            this.tableData = res.data.resultData;
          }
        });
    },
    // 清除违章缓存
    clearCache () {
      this.axios.post(`/member/getCarVehInfo`, {
        memberId: this.$store.state.memberId,
        clsbh: this.carInfo.clsbh,
        plateNumber: this.carInfo.plateNumber,
        type: 1 // 0查询 1清除缓存
      })
        .then(res => {
          if (res.data.isSuccess) {
            this.$message.success('操作成功');
            this.getData();
          }
        });
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.checkVehInfo();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.checkVehInfo();
    },
    // 搜索
    submitSearch () {
      this.searchParams.pageIndex = 0;
      this.currentPage = 1;
      this.checkVehInfo();
    },
    // 打开编辑-车辆信息
    editCarInfo (str) {
      this.carDataEdit['edit' + str] = true;
      this.carDataEdit['data' + str] = '';
    },
    // 打开编辑-车辆品牌信息
    editCarBrandInfo () {
      this.getCarBrand();
      this.carDataEdit.editCarBrand = true;
      this.carDataEdit.dataCarBrand1 = '';
      this.carDataEdit.dataCarBrand2 = '';
      this.carDataEdit.dataCarBrand3 = '';
      this.carDataEdit.dataCarBrand4 = '';
    },
    // 打开编辑-车辆信息
    saveCarInfo (str) {
      if (str === 'Color') {
        this.updateCarInfo({csys: this.carDataEdit.dataColor}, () => { this.carDataEdit['edit' + str] = false; });
      } else if (str === 'Price') {
        this.updateCarInfo({gmjg: this.carDataEdit.dataPrice}, () => { this.carDataEdit['edit' + str] = false; });
      } else if (str === 'DriveKm') {
        this.updateCarInfo({driveKm: this.carDataEdit.dataDriveKm}, () => { this.carDataEdit['edit' + str] = false; });
      } else if (str === 'RegDate') {
        this.updateCarInfo({regDate: this.carDataEdit.dataRegDate}, () => { this.carDataEdit['edit' + str] = false; });
      } else if (str === 'BxDate') {
        this.updateCarInfo({startDate: this.carDataEdit.dataBxDate}, () => { this.carDataEdit['edit' + str] = false; });
      } else if (str === 'CarBrand') {
        this.updateCarInfo({brand: this.carDataEdit.dataCarBrand4}, () => {
          this.getData();
          this.carDataEdit['edit' + str] = false;
        });
      }
    },
    // 打开编辑-车辆信息
    cancleCarInfo (str) {
      this.carDataEdit['edit' + str] = false;
    },
    // 修改车辆信息
    /*
      // 车身颜色
      csys: this.carDataEdit.dataColor,
      // 购车价格
      gmjg: this.carDataEdit.dataPrice,
      // 车辆品牌信息
      brand: this.carDataEdit.dataCarBrand1 + ' ' + this.carDataEdit.dataCarBrand2 + ' ' + this.carDataEdit.dataCarBrand3 + ' ' + this.carDataEdit.dataCarBrand4,
      // 行驶里程
      driveKm: this.carDataEdit.dataDriveKm,
      // 注册日期
      regDate: this.carDataEdit.dataRegDate,
      // 保险办理时间
      startDate: this.carDataEdit.dataBxDate
    * */
    updateCarInfo (params, cb) {
      params.memberId = this.$store.state.memberId;
      params.vehBindId = this.carInfo.bindId;
      this.axios.post(`/member/updateMemberCarInfo`, params)
        .then(res => {
          if (res.data.isSuccess) {
            this.$message.success('操作成功');
            'csys' in params && (this.carInfo.csys = this.carDataEdit.dataColor);
            'gmjg' in params && (this.carInfo.gmjg = this.carDataEdit.dataPrice);
            'driveKm' in params && (this.carInfo.driveKm = this.carDataEdit.dataDriveKm);
            'regDate' in params && (this.carInfo.regDate = this.carDataEdit.dataRegDate);
            'startDate' in params && (this.carInfo.insuranceExpire = this.carDataEdit.dataBxDate);
            cb && cb();
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#customerCarInfo{min-width: 800px;  margin: 10px 0 0 330px;}
.container{padding: 10px;}
.inlineBlock{display: inline-block; width: 100%;}

.changeEditable{
  & > .el-input{width: 130px;}
  & > .el-select{width: 100px;}
  &.small > .el-select{width: 75px;}
}

.lineRight{position: absolute; right: 0; top: 0;}

.likeA{cursor: pointer; color: $theme-color-blue;
  &:hover{text-decoration: underline;}}

.iconAble{margin-left: 5px; cursor: pointer; font-size: 16px;}
.edit:hover{color: $theme-color-blue;}

.el-form-item{margin-bottom: 0;}
</style>



// WEBPACK FOOTER //
// src/components/customerCheck/carInfo.vue